import { Configuration, UserApi } from '@rtkwlf/capability';

import { fetchWithToken } from '@platform/core/auth';

import { env } from '@packages/utils/env';

const client = new UserApi(
  new Configuration({
    basePath: env.VITE_CAPABILITY_BASE_PATH,
    fetchApi: fetchWithToken,
  }),
);

export const getCapabilityApiClient = () => client;
